module.exports = __webpack_public_path__ + "img/maintenance-2.e8dde157.png";